<template>
  <div class="system-notice">
    <span class="system-notice-label">
      <icon-alert />
      <span> {{ t('common.note') }}: </span>
    </span>
    <p class="system-notice-text">
      {{ text }}
    </p>
  </div>
</template>

<script setup lang="ts">
import IconAlert from '../../assets/icons/IconAlert.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface SystemNoticeProps {
  text: string;
}
defineProps<SystemNoticeProps>();
</script>

<style scoped lang="scss">
@use '../../assets/styles/colors' as colors;
@use 'sass:map';

.system-notice {
  align-items: center;
  background-color: map.get(colors.$colors, 'cornflower-blue-super-light');
  display: flex;
  gap: 26px;
  padding: 8px 24px;

  .system-notice-label {
    align-items: center;
    color: map.get(colors.$colors, 'fun-blue');
    display: inline-flex;
    font-weight: bold;
    font-size: 12px;
    gap: 16px;
  }
}
</style>
